// import { styled } from "@linaria/react";
import { styled } from "@linaria/react";
import React from "react";

type EllipsisProps = {
  maxNumberOfLines?: number;
  title?: string;
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLSpanElement>;

const Ellipsis = ({ children, title, maxNumberOfLines, ...props }: EllipsisProps) => (
  <span
    {...props}
    title={title ? title : typeof children === "string" ? children : undefined}
    style={{
      ...(maxNumberOfLines && maxNumberOfLines > 1
        ? {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: maxNumberOfLines,
          }
        : {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }),
      ...(props.style ?? {}),
    }}
  >
    {children}
  </span>
);

export default styled(Ellipsis)``;

// export default styled(Ellipsis)`
//   color: currentColor;
// `;
